<template>
    <div class="bigBoss">
        <el-dialog title="详情" width="550px" :visible="detail.isShow" :close-on-click-modal="false" @close="handleClose">
            <div class="title">
                <p>
                    <span>{{titleCount}}：</span>
                </p>
            </div>
            <template>
                <el-select v-model="value" placeholder="请选择终端类型" v-if="this.detail.type == 1" multiple style="width: 200px">
                    <el-option
                        v-for="item in brandList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-button type="primary" @click="brandEdit" v-if="this.detail.type == 1">提交</el-button>
            </template>
            <el-table
                    :data="stockInfoList"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading">
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="name"
                        label="终端类型"
                        min-width="80"
                        v-if="this.detail.type == 1"
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="sn"
                        label="sn"
                        min-width="80"
                        v-if="this.detail.type == 3"
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="real_name"
                        label="用户"
                        min-width="80"
                        v-if="this.detail.type == 2"
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="phone"
                        label="电话"
                        min-width="80"
                        v-if="this.detail.type == 2"
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="agent_name"
                        label="主机构"
                        min-width="80"
                        v-if="this.detail.type == 4"
                ></el-table-column>
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed="right"
                        v-if="this.detail.type == 1"
                        label="操作"
                        min-width="140">
                    <template slot-scope="scope">
                        <el-button @click="brandHandleInfo(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                    small
                    layout="prev, pager, next"
                    @current-change="getCurrent"
                    :total="page.total"
            ></el-pagination>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MAM_stockInfo",
    props: {
        detail: {
            type: Object
        }
    },
    data() {
        return {
            stockInfoList: [],
            title: {
                brandName: '',
                belongTo: '',
                count: ''
            },
            terminal_sn: '',
            leftName: '',
            rightName: '',
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: false,
            brandList:[],
            value: ''
        };
    },
    mounted() {
        this.getData({
            page: this.page.currentPage,
            limit: this.page.pageSize,
            type: this.detail.type,
            id: this.detail.info.id,
        });
        this.$api.post('brand/brand_list', {}, res => { //获取终端类型
            if (res.code == 0) {
                this.brandList = res.data.list;
            } else {
                this.$message.error(res.msg);
            }
        })
    },
    methods: {
        onSearch(terminal_sn) {
            this.getData({
                page: this.page.currentPage,
                limit: this.page.pageSize,
                type: this.detail.type,
                id: this.detail.info.id,
            });
        },
        handleClose(ref) { //关闭弹窗
            this.$emit('infoClose', ref);
        },
        //分页
        getCurrent(page) {
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.loading = true;
            this.getData({
                id: this.detail.info.id,
                page: this.page.currentPage,
                limit: this.page.pageSize,
                type: 1,
            });
        },
        getData(params) {
            this.$api.post('transaction/transaction_hide_detail', params, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.stockInfoList = data.list; //列表
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        brandHandleInfo(data){
            let that = this;
            this.$api.post('transaction/transaction_hide_detail_edit', {type:1,edit_id:data,id:this.detail.info.id}, res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 300,
                        onClose() {
                            that.handleClose(1); //刷新父页面
                        }
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        brandEdit()
        {
            let that = this;
            this.$api.post('transaction/transaction_hide_detail_update', {type:1,edit_id:this.value,id:this.detail.info.id}, res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 300,
                        onClose() {
                            that.handleClose(1); //刷新父页面
                        }
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    },
    computed: {
        titleCount() {
            let title;
            switch (this.detail.type) {
                case 1:
                    title = '优化终端类型';
                    break;
                case 2:
                    title = '非优化代理商';
                    break;
                case 3:
                    title = '非优化终端';
                    break;
                case 4:
                    title = '主机构';
                    break;
            }
            return title;
        }
    }
};
</script>

<style scoped lang="scss">
.bigBoss {
  font-size: 12px;
  .el-input__inner,
  .tips {
    font-size: 12px;
  }

  .el-form-item {
    margin-bottom: 5px;
  }

  ::v-deep .el-form-item__label {
    padding: 0;
    font-size: 12px;
  }
  .titleTip {
    padding: 10px 10px;
    background-color: #ecf8ff;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 700;
    border-left: 5px solid #50bfff;
    margin: 10px 0;
  }
  .title p {
    font-size: 12px;
    :first-child {
      font-weight: 700;
    }
  }
}
</style>